import axios from "@core/plugins/axios.plugin"
import { handleServiceCall } from "@services/helpers"

export class RapportService {
    /**
     * Crée un rapport excel
     *
     * @param filename - Nom du fichier
     * @param sheets - Liste des feuilles
     *
     * @returns L'url du fichier
     */
    async createRapport(
        filename: string,
        sheets: {
            sheetname: string
            columns: {
                colname: string
                values: any[]
            }[]
        }[]
    ): Promise<string> {
        return handleServiceCall<string>(async () => {
            const { data } = await axios.post("/api/rapport/excel/generate", {
                filename,
                sheets,
            })

            return data?.url
        })
    }
}
